import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { withError, withValidation, AdapterFactory } from '@bingads-webui-react/validation';
import { withControlErrorHandling, withUnvalidatedControlErrors } from '@bingads-webui-campaign-react/error-handling';
import { BaseTextField } from './base-text-field';
import { validateTextField } from '../validators';

const Adapter = AdapterFactory({ convertEventToValue: value => value, functionToInject: 'updateItem' });
const validatedTextField = withValidation(BaseTextField, Adapter);
const ValidatedTextFieldWithErrors = withControlErrorHandling(withUnvalidatedControlErrors(withError(validatedTextField)));

const getTextInputContainerStyles = () => ({
  TextInputContainer: {
    width: '435px',
    '& div .error': {
      color: '#A80000',
    },
  },
});

export const TextFieldWithAdCustomizerInternal = React.memo((props) => {
  const {
    i18n, adType, containerSelector, configProps, validationProps,
  } = props;

  const classes = useDefaultStyles(getTextInputContainerStyles);
  const customizedValidator = (newData) => {
    const isRequired = _.property(['schema', 'properties', configProps.id, 'required'])(validationProps);
    if (isRequired && _.isEmpty(newData)) {
      return [i18n.getString(_TL_('Required field'))];
    }
    const errorMessage = validateTextField(configProps.key, i18n, true, adType)(newData);
    return errorMessage === '' ? [] : [errorMessage];
  };
  const newValidationProps = {
    ...validationProps,
    validator: customizedValidator,
  };

  return (
    <div className={classnames('text-input-container', classes.TextInputContainer)}>
      <ValidatedTextFieldWithErrors
        {...props}
        showCharRemaining
        adType={adType}
        containerSelector={containerSelector}
        showErrorMessage={false}
        updateItem={_.noop}
        validationProps={newValidationProps}
      />
    </div>
  );
});

TextFieldWithAdCustomizerInternal.propTypes = {
  updateValidation: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  adType: PropTypes.string,
  containerSelector: PropTypes.string,
  configProps: PropTypes.shape({
    id: PropTypes.string,
    key: PropTypes.string,
  }).isRequired,
  validationProps: PropTypes.shape({
    data: PropTypes.shape({}),
    field: PropTypes.string,
  }).isRequired,
};

TextFieldWithAdCustomizerInternal.defaultProps = {
  adType: 'ResponsiveAd',
  containerSelector: 'div.crud-multimedia-ad-react .ad-edit-and-preview-container',
};

export const ValidatedTextFieldWithAdCustomizer = (TextFieldWithAdCustomizerInternal);
